import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { userAccountTranslationChunksConfig, userAccountTranslationsCs } from '@spartacus/user/account/assets';
import { UserAccountRootModule, USER_ACCOUNT_FEATURE } from '@spartacus/user/account/root';
import { userProfileTranslationChunksConfig, userProfileTranslationsCs } from '@spartacus/user/profile/assets';
import { UserProfileRootModule, USER_PROFILE_FEATURE } from '@spartacus/user/profile/root';

@NgModule({
  declarations: [],
  imports: [
    UserAccountRootModule,
    UserProfileRootModule
  ],
  providers: [provideConfig({
    featureModules: {
      [USER_ACCOUNT_FEATURE]: {
        module: () =>
          import('@spartacus/user/account').then((m) => m.UserAccountModule),
      },
    }
  } as CmsConfig),
  provideConfig({
    i18n: {
      resources: userAccountTranslationsCs,
      chunks: userAccountTranslationChunksConfig,
    },
  } as I18nConfig),
  provideConfig({
    featureModules: {
      [USER_PROFILE_FEATURE]: {
        module: () =>
          import('@spartacus/user/profile').then((m) => m.UserProfileModule),
      },
    }
  } as CmsConfig),
  provideConfig({
    i18n: {
      resources: userProfileTranslationsCs,
      chunks: userProfileTranslationChunksConfig,
    },
  } as I18nConfig)
  ]
})
export class UserFeatureModule { }
